import { render, staticRenderFns } from "./CategoryFinish.vue?vue&type=template&id=3aeae7a5&scoped=true&"
import script from "./CategoryFinish.vue?vue&type=script&lang=js&"
export * from "./CategoryFinish.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFinish.vue?vue&type=style&index=0&id=3aeae7a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeae7a5",
  null
  
)

export default component.exports